import { Pipe, PipeTransform } from '@angular/core';
import { PendingActivationStatus } from '@vendasta/order-fulfillment';

@Pipe({
  name: 'isActivationPending',
  standalone: true,
})
export class IsActivationPendingPipe implements PipeTransform {
  transform(status: string | PendingActivationStatus | undefined): boolean {
    return (
      status === PendingActivationStatus.PENDING_ACTIVATION_STATUS_PENDING ||
      status === 'PENDING_ACTIVATION_STATUS_PENDING'
    );
  }
}
